import { Button } from "@/components/ui/button";

export const WelcomeScreen = ({ onStart }) => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 fade-in">
      <div className="max-w-3xl w-full space-y-10 text-center px-4">
        <div className="space-y-8">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[hsl(var(--text-primary))] leading-[1.1]" style={{ letterSpacing: '-0.02em' }}>
            Sistema de Análisis Estratégico del Negocio
          </h1>
          
          <div className="space-y-5 text-base md:text-lg text-[hsl(var(--text-secondary))] leading-relaxed max-w-2xl mx-auto" style={{ letterSpacing: '-0.01em' }}>
            <p className="text-lg">
              Este sistema analiza tu negocio y detecta, con criterio estratégico,
              dónde la automatización y la IA pueden ayudarte de verdad.
            </p>
            <p>
              No es una auditoría genérica ni una lista de herramientas.
            </p>
            <p>
              Si respondes con honestidad, obtendrás un mapa inicial para eliminar el ruido
              y encontrar dónde la IA genera impacto real en tu negocio.
            </p>
          </div>
        </div>

        <div className="pt-8">
          <Button
            onClick={onStart}
            size="lg"
            className="w-full max-w-md mx-auto h-14 text-base font-semibold"
          >
            Empezar análisis
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
